export default __webpack_public_path__ + "static/news-section-ice2-image-9336755b0b8e5ff37d5f5b352eefa85b.webp";